import { Alert } from "react-bootstrap";
import React, { useState, useEffect } from "react";
import { useAuth } from "../../contexts/AuthContext";
import {
  ClaimContract,
} from "../Database/Functions";
import ListContracts from "./ListContracts";
import { useHistory } from "react-router-dom";
import Header from "../UI/Header/Header";
import Section from "../UI/Section/Section";

const debug = false;

function AllContracts(props) {
  const [hasUpdates, setHasUpdates] = useState(false);
  const [alert, setAlert] = useState();
  const { currentUser, contracts, rerfreshContracts} = useAuth();
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(true);
  const [isFirstUpdate, setIsFirstUpdate] = useState(true);

  const showOnlyPersonal = props.type == "personal" ? true : false;
  

  //Load Bets
  useEffect(() => {

    if (isFirstUpdate){
      //because we don't want to force update all the time
      setIsFirstUpdate(false); 
      setIsLoading(false);
    } else {
      setIsLoading(true);
      rerfreshContracts(true).then((r)=>{
        setIsLoading(false);
      });
    }

    setHasUpdates(false);
  }, [hasUpdates]);

  // Взять задачу
  function getContractHandler(id, party) {
    // TODO: сделать дополнительный запрос, проверить, может кто-то взял, исключить одновременность
    ClaimContract(id, currentUser.uid)
      .then(() => {
        setAlert({ msg: "Отпавлен запрос на задачу" });
        window.scrollTo(0, 0);
      })
      .catch((error) => {
        setAlert({ variant: "danger", msg: error.message });
        window.scrollTo(0, 0);
      });
  }

  debug && console.log("Contracts", contracts);

  if (contracts == undefined || !contracts || isLoading ) {
    return <p>загрузка...</p>;
  }
  return (
    <>
      {alert && (
        <Alert variant={alert.variant ? alert.variant : "success"}>
          {alert.msg}
        </Alert>
      )}
      {!showOnlyPersonal && (
        <Section>
          <Header>Задания</Header>
          <ListContracts
            contracts={contracts.filter((contract) => !contract.claims && !contract.party && contract.status < 2)}
            onGetContract={getContractHandler}
          />
        </Section>
      )}
      <Section>
        <Header>В работе</Header>
        <ListContracts
          contracts={contracts.filter((contract) => {
            return contract.party == currentUser.uid && contract.status < 2;
          })}
          onGetContract={getContractHandler}
        />
      </Section>
      <Section>
        <Header>Архив</Header>
        <ListContracts
          contracts={contracts.filter((contract) => {
            return contract.party == currentUser.uid && contract.status == 2;
          })}
          onGetContract={getContractHandler}
        />
      </Section>
    </>
  );
}
export default AllContracts;
